import {Component, EventEmitter, Input, Output} from '@angular/core';
// TODO(RZ-2562): Replace legacy VO types (TrustAnchorVO) with SDK equivalents (TrustAnchor)
import {TrustAnchorVO} from '../../../../generate/TopLevelDomainVO';
import {ChangeVO} from '../../../../generate/ChangeVO';
import {UtilService} from '../../../../util/util.service';

@Component({
    selector: 'lib-ds-records-view',
    templateUrl: './ds-records-view.component.html',
    styleUrls: ['./ds-records-view.component.scss'],
    standalone: false
})
export class DsRecordsViewComponent {
  @Input()
  trustAnchors: Array<TrustAnchorVO>;

  @Input()
  pendingRequestChangeID: string;

  @Input()
  trustAnchorsChange: ChangeVO;

  @Input()
  lastchange: string;

  @Input()
  hasTechnicalPermission: boolean;

  @Output()
  edit = new EventEmitter<boolean>();
  @Input()
  viewMode: boolean;
  constructor(private util: UtilService) {
  }

  ngOnChanges() {
    if (this.trustAnchorsChange != null) {
      this.buildTrustAnchorsFromChangeVO();
    }
  }

  onEdit(): void {
    this.edit.emit(true);
  }

  private buildTrustAnchorsFromChangeVO() {
    this.trustAnchors = [];
    this.util.buildObjectFromChange(this.trustAnchors, this.trustAnchorsChange);
  }
}
